export default __webpack_public_path__ + "static/media/cancelled.e1726fbc.svg";